interface Props {
    startDate: string;
    availableBalance: string | null;
    leftToPay?: string | null;
}

const FACT_CLASSES = "flex gap-1 not-last:after:ml-1 not-last:after:content-['·']";

export function AgreementKeyFacts({ startDate, availableBalance, leftToPay }: Props) {
    return (
        <dl className="flex flex-wrap gap-x-2 gap-y-1">
            <div className={FACT_CLASSES}>
                <dt>Start date</dt>
                <dd className="font-medium text-mp-foreground">{startDate}</dd>
            </div>
            <div className={FACT_CLASSES}>
                <dt>Available balance (inc VAT)</dt>
                <dd className="font-medium text-mp-foreground">{availableBalance ?? '—'}</dd>
            </div>
            {leftToPay != null && (
                <div className={FACT_CLASSES}>
                    <dt>Left to pay</dt>
                    <dd className="font-medium text-mp-foreground">{leftToPay}</dd>
                </div>
            )}
        </dl>
    );
}
